import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Link, LinkType, Menu } from 'sidecar-components'

import { helpMenuStyles } from './HelpNav.styles'

export const EnrollmentHelpNav = ({ logout, authenticated = false }) => {
  const location = useLocation()

  // controls whether the acct menu is open or not
  const [isAcctMenuOpen, setIsAcctMenuOpen] = useState(false)
  const handleOpenAcctMenu = e => {
    e.preventDefault()
    setIsAcctMenuOpen(!isAcctMenuOpen)
  }

  // Don't show anything if we're on the login page
  if (location.pathname === '/login') {
    return null
  }

  return !authenticated ? (
    // If you have not logged in yet, offer a link to do so
    <Link
      path="/login"
      type={LinkType.INTERNAL}
      // make the text a little smaller on mobile
      className="max-md:text-sm"
      testId="link_login"
    >
      Log in
    </Link>
  ) : (
    // If you have logged in, offer a mini version of the account menu with only options available to a non-purchased member
    <Menu
      className={helpMenuStyles}
      trigger={
        <Link
          path="/account"
          type={LinkType.INTERNAL}
          onClick={handleOpenAcctMenu}
          // make the text a little smaller on mobile
          className="max-md:text-sm"
          testId="btn_enrollmentAccountNav"
        >
          Account
        </Link>
      }
      sections={[
        {
          items: [
            {
              icon: 'verify',
              title: 'Finish signup',
              subtitle: 'Complete your application to enroll in coverage',
              path: '/signup',
              pathType: LinkType.INTERNAL,
            },
          ],
        },
        {
          items: [
            {
              icon: 'customer',
              title: 'Profile',
              subtitle: 'Personal and contact info',
              path: '/account/profile',
              pathType: LinkType.INTERNAL,
            },
            {
              icon: 'lock',
              title: 'Security',
              subtitle: 'Edit your password and view login history',
              path: '/account/profile/security',
              pathType: LinkType.INTERNAL,
            },
          ],
        },
        {
          items: [
            {
              title: 'Logout',
              onClick: e => {
                logout()
                // this preventDefault makes sure that the menu item doesn't
                // try to navigate to a page. That's handled elsewhere.
                e.preventDefault()
              },
            },
          ],
        },
      ]}
    />
  )
}
